var map = {
	"./ackama-lockup.svg": 2386,
	"./add-2.svg": 2103,
	"./add.svg": 526,
	"./admin/archived.svg": 2991,
	"./admin/pending.svg": 7238,
	"./admin/published.svg": 5513,
	"./agree.svg": 1235,
	"./archive.svg": 2037,
	"./avatar.svg": 9962,
	"./bad-example.jpg": 1864,
	"./bell.svg": 4218,
	"./black.png": 4725,
	"./by-nc-sa.png": 9672,
	"./camera.svg": 1016,
	"./checkbox-checked.svg": 5134,
	"./checkbox-hover.svg": 5651,
	"./checkbox.svg": 4290,
	"./chevron-right.svg": 6847,
	"./chosen-sprite-adjusted.png": 8889,
	"./chosen-sprite.png": 4900,
	"./chosen-sprite@2x.png": 3444,
	"./close.svg": 407,
	"./comment.svg": 4672,
	"./control-play.svg": 6951,
	"./disagree.svg": 421,
	"./dropdown-light.svg": 6665,
	"./dropdown.svg": 1810,
	"./dummy.mp4": 8708,
	"./edit.svg": 8505,
	"./emotsmile.svg": 4946,
	"./external-link.svg": 3605,
	"./eye.svg": 2504,
	"./facebook-light.svg": 9546,
	"./facebook.svg": 5185,
	"./flag.svg": 2195,
	"./folder-add.svg": 2827,
	"./folder-alt.svg": 2563,
	"./folder-collection.svg": 2486,
	"./folder-success.svg": 4791,
	"./github.svg": 8228,
	"./good-example.jpg": 8996,
	"./hero-image.jpg": 9750,
	"./hero-play-dropshadow.svg": 1942,
	"./hero-play.svg": 1476,
	"./hero-thumbnail.jpg": 2961,
	"./home-intro.mp4": 9658,
	"./home-intro.webm": 5942,
	"./home.svg": 4748,
	"./home/camera-2.svg": 3191,
	"./home/conversation-check.svg": 6029,
	"./home/folder.svg": 9651,
	"./home/rectangle.svg": 9222,
	"./home/upload.svg": 832,
	"./learn-NZSL-sq.png": 7879,
	"./logo-stacked.svg": 472,
	"./logo.svg": 3208,
	"./moderator.svg": 3774,
	"./nzsl-share-favicon.svg": 8621,
	"./nzsl_logo.jpg": 4333,
	"./ok.svg": 7491,
	"./options.svg": 2241,
	"./private.svg": 6318,
	"./processing.svg": 7540,
	"./radio-checked.svg": 2554,
	"./radio-hover.svg": 4079,
	"./radio.svg": 5662,
	"./record.svg": 5818,
	"./remove.svg": 3289,
	"./reply.svg": 4603,
	"./search.svg": 5797,
	"./share.svg": 6426,
	"./table.svg": 5683,
	"./tags.svg": 8006,
	"./text.svg": 7488,
	"./tick.svg": 1170,
	"./trash.svg": 2065,
	"./twitter.svg": 7742,
	"./user.svg": 4948,
	"./users.svg": 5327,
	"./video-play.svg": 6721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8257;